'use strict';

exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Poništi'
    },
    datepicker: {
      now: 'Sad',
      today: 'Danas',
      cancel: 'Otkaži',
      clear: 'Briši',
      confirm: 'OK',
      selectDate: 'Izaberi datum',
      selectTime: 'Izaberi vreme',
      startDate: 'Datum početka',
      startTime: 'Vreme početka',
      endDate: 'Datum završetka',
      endTime: 'Vreme završetka',
      prevYear: 'Prethodna godina',
      nextYear: 'Sledeća godina',
      prevMonth: 'Prethodni mesec',
      nextMonth: 'Sledeći mesec',
      year: 'godina',
      month1: 'januar',
      month2: 'februar',
      month3: 'mart',
      month4: 'april',
      month5: 'maj',
      month6: 'jun',
      month7: 'jul',
      month8: 'avgust',
      month9: 'septembar',
      month10: 'oktobar',
      month11: 'novembar',
      month12: 'decembar',
      week: 'sedmica',
      weeks: {
        sun: 'Ned',
        mon: 'Pon',
        tue: 'Uto',
        wed: 'Sre',
        thu: 'Čet',
        fri: 'Pet',
        sat: 'Sub'
      },
      months: {
        jan: 'jan',
        feb: 'feb',
        mar: 'mar',
        apr: 'apr',
        may: 'maj',
        jun: 'jun',
        jul: 'jul',
        aug: 'avg',
        sep: 'sep',
        oct: 'okt',
        nov: 'nov',
        dec: 'dev'
      }
    },
    select: {
      loading: 'Učitavanje',
      noMatch: 'Nema rezultata',
      noData: 'Nema podataka',
      placeholder: 'Izaberi'
    },
    cascader: {
      noMatch: 'Nema rezultata',
      loading: 'Učitavanje',
      placeholder: 'Izaberi',
      noData: 'Nema podataka'
    },
    pagination: {
      goto: 'Idi na',
      pagesize: '/strani',
      total: 'Ukupno {total}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'Poruka',
      confirm: 'OK',
      cancel: 'Otkaži',
      error: 'Neisravan unos'
    },
    upload: {
      deleteTip: 'pritisni BRIŠI da obrišeš',
      delete: 'Briši',
      preview: 'Vidi',
      continue: 'Nastavi'
    },
    table: {
      emptyText: 'Nema podataka',
      confirmFilter: 'Potvrdi',
      resetFilter: 'Resetuj',
      clearFilter: 'Sve',
      sumText: 'Zbir'
    },
    tree: {
      emptyText: 'Nema podataka'
    },
    transfer: {
      noMatch: 'Nema rezultata',
      noData: 'Nema podataka',
      titles: ['Lista 1', 'Lista 2'],
      filterPlaceholder: 'Unesi ključnu reč',
      noCheckedFormat: '{total} stavki',
      hasCheckedFormat: '{checked}/{total} obeleženih'
    },
    image: {
      error: 'NEUSPEŠNO'
    },
    pageHeader: {
      title: 'Nazad'
    },
    popconfirm: {
      confirmButtonText: 'Da',
      cancelButtonText: 'Ne'
    },
    empty: {
      description: 'Nema podataka'
    }
  }
};